import type { ComponentProps, ReactNode } from 'react'
import { type VariantProps } from 'tailwind-variants'

import { inputVariants } from './input.styles'
import { InputGroup } from './input-group'
import { isAriaInvalid } from './is-aria-invalid'

type InputVariantProps = VariantProps<typeof inputVariants>

export type InputProps = Omit<ComponentProps<'input'>, 'size'> &
  InputVariantProps & {
    startAddon?: ReactNode
    endAddon?: ReactNode
  }

export const Input = ({
  className,
  size,
  variant,
  textAlign,
  startAddon,
  endAddon,
  ...props
}: InputProps) => {
  const { input } = inputVariants({ size, variant, textAlign })

  return (
    <InputGroup
      className={className}
      endAddon={endAddon}
      invalid={isAriaInvalid(props['aria-invalid'])}
      size={size}
      startAddon={startAddon}
      variant={variant}
    >
      <input
        className={input()}
        data-slot="input-group-control"
        {...props}
      />
    </InputGroup>
  )
}
